import {fetchGet, generateEndpoint} from "../utils/request";

export const getOrganizations = async({ token }) => {
  const url = `${generateEndpoint('getOrganizations')}`
  return fetchGet(url, token)
}

export const getOrganizationById = async({ token, id }) => {
  const url = `${generateEndpoint('getOrganization')}?id=${id}`
  return fetchGet(url, token)
}
